import { dynamicLoader } from '~/utils';

export const ProfitAnalysisPage = dynamicLoader({
  name: 'ProfitAnalysisPage',
  importFunc: () => import('./profit-analysis'),
});